import * as React from 'react'
import { Colors } from '../../../constants/colors'
import { BaseIconProps } from '../types'

function SalesforceRoleIcon({ size = 30, color = Colors.N100, title }: BaseIconProps) {
  return (
    <svg width={size} height={size} fill="none" viewBox="0 0 24 24">
      <title>{title}</title>
      <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z" stroke={color} />
      <path clipRule="evenodd" d="M3 18h10l1-2s-1.5-3-6-3-6 3-6 3l1 2Z" stroke={color} strokeLinejoin="round" />
      <path
        d="m20.464 8.527.743 1.287-.743 1.286H18.98l-.742-1.286.742-1.287h1.485ZM16.542 5.208a1.333 1.333 0 1 1-2.667 0 1.333 1.333 0 0 1 2.667 0ZM14.184 11.125l1.024-2.049 1.025 2.049h-2.049Z"
        stroke={color}
      />
      <mask id="a" fill="#fff">
        <rect x={17.958} y={3.375} width={3.667} height={3.667} rx={0.3} />
      </mask>
      <rect x={17.958} y={3.375} width={3.667} height={3.667} rx={0.3} stroke={color} strokeWidth={2} mask="url(#a)" />
    </svg>
  )
}

export default SalesforceRoleIcon
